import { UserManager } from 'oidc-client'
import EventEmitter, {
  DISABLE_BLOCK_NAVIGATION,
  SESSION_TIME_OUT,
  SHOW_LOADING_SCREEN,
} from '../components/helpers/EventEmitter'
import { localStorageKeys } from '../components/utils/common'
import { identityServerConfig } from '../configs/identityServer'

class AuthenticationProvider {
  _usrMgr
  constructor() {
    this._usrMgr = new UserManager(identityServerConfig)
    let me = this
    this._usrMgr.events.addSilentRenewError(function (e) {
      me._usrMgr.getUser().then((user) => {
        if (!user || user.expired) {
          EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, true)
          EventEmitter.dispatch(SESSION_TIME_OUT, '')
        }
      })
    })

    this._usrMgr.events.addUserSessionChanged(() => {
      console.log('fire')
    })
  }

  getStoreKey() {
    return `user:${identityServerConfig.authority}:${identityServerConfig.client_id}`
  }

  async getUser() {
    const user = await this._usrMgr.getUser()
    if (user && !user?.profile?.user_id) {
      return this.signout()
    }

    return user
  }

  signin() {
    localStorage.setItem(
      localStorageKeys.RETURN_URL,
      window.location.pathname + window.location.search,
    )
    const query = new URLSearchParams(window.location.search)
    this._usrMgr.signinRedirect({
      //Bổ sung thêm 2 tham số truyền sang Identity Server
      extraQueryParams: {
        refCode: query.get('refCode') || '',
        refUserId: query.get('refUserId') || '',
      },
    })
  }

  signinCallback() {
    EventEmitter.dispatch(SHOW_LOADING_SCREEN, false)
    return this._usrMgr.signinRedirectCallback()
  }

  signout() {
    return this._usrMgr.signoutRedirect()
  }

  signinSilentCallback() {
    return this._usrMgr.signinSilentCallback()
  }

  signinSilent() {
    return this._usrMgr.signinSilent()
  }

  signinPopup() {
    return this._usrMgr.signinPopup()
  }

  clearStaleState() {
    return this._usrMgr.clearStaleState()
  }
}

const authProvider = new AuthenticationProvider()
export default authProvider
